import script from "./TiltCard.vue?vue&type=script&setup=true&lang=js"
export * from "./TiltCard.vue?vue&type=script&setup=true&lang=js"

import "./TiltCard.vue?vue&type=style&index=0&id=3118ded1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3118ded1"]])

export default __exports__